export interface LogEntry {
    method: string;
    url: string;
    status: number;
    error?: string;
    ts: string;
}

const logs: LogEntry[] = [];

export function logRequest(method: string, url: string, status: number, error?: string) {
    // Clean URL
    try {
        const u = new URL(url, 'http://localhost');
        url = u.pathname;
    } catch { }

    logs.unshift({
        method,
        url,
        status,
        error: error ? error.substring(0, 100) : undefined,
        ts: new Date().toLocaleTimeString()
    });

    if (logs.length > 25) logs.pop();
}

export function getLogs() {
    return logs;
}
